// extracted by mini-css-extract-plugin
export var element = "Link-module--element--3xmqU";
export var linkInText = "Link-module--linkInText--KqH9f";